import React from 'react';

const CustomCheckbox = props => (
  <div className='checkbox'>
    <label htmlFor={props.id}>
      <input type='checkbox' onChange={props.onChange} name={props.name} value={props.id} id={props.id} checked={props.isChecked === props.id} />
      {props.label}
      <div className='checkbox-skin' />
    </label>
  </div>
);

export default CustomCheckbox;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/CustomCheckbox.js